<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">


			<div class="bg2">
				<div class="main3">

					<div class="bread">
						<div class=""></div>
						<div class="bread_c"><a href="javascript:void(0);" @click="goNext('/')">主页> </a> <a
								href="javascript:void(0);" @click="go('/newList?level=1&type='+detail.oneCategoryCode)"
								v-if="detail.oneCategoryCode">{{detail.oneCategoryName}}></a> <a
								href="javascript:void(0);">{{detail.categoryName}}</a> </div>
					</div>
					<div class="news_title">
						{{detail.title}}
					</div>
					<div v-if="simple" class="news_laiyuan">来源：{{detail.copyfrom}}</div>
					<div v-else class="news_laiyuan">浏览次数：{{detail.hits}} 发布时间：{{detail.createTime}} 作者：{{detail.author}}
						来源：{{detail.copyfrom}}</div>
					<div class="news_c" v-if="!pdfUrl" v-html="detail.cmsArticleData?detail.cmsArticleData.content:''">

					</div>
					<div class="news_c"  v-if="fileList">
						
						<ul class="fujian_list">
							<li v-for="item in fileList"><a :href="item.url" target="_blank">
									{{item.fileOriName}}

								</a></li>
						</ul>
					</div>
					<div class="news_c pc_img" style="text-align: center; padding-top: 15px;">
						<p>手机扫一扫打开此页</p><img :src="detail.qrCode" />
					</div>
					<div class="neirong_c" v-if="pdfUrl">
						<!-- <iframe :src="pdfUrl" width="600" height="800"></iframe> -->

						<!-- <canvas ref="pdfCanvas" width="600" height="800"></canvas> -->
						<object :data="pdfUrl" type="application/pdf" width="100%" height="700px">
							<!-- 若浏览器不支持 PDF 显示，显示提示信息 -->
							<p>Your browser does not support PDF viewing. Please <a :href="pdfUrl">download the PDF</a>.
							</p>
						</object>

					</div>

				</div>

			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
        simple: false,
			}
		},

		mounted() {
			this.id = this.$route.query.id
      this.simple = this.$route.query.simple ? true : false
			this.getNewDetail();
		},

		methods: {
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
							let cmsArticleData = this.detail.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
					this.fileList = res.data.fileList;
					if (res.data.fileList.length > 0 && res.data.fileList[0].fileExt == ".pdf") {
						// this.pdfUrl = res.data.fileList[0].url
						axios.get(res.data.fileList[0].url, {
							timeout: 60000,
							responseType: 'blob'
						}).then(res => {
							const binaryData = [];
							binaryData.push(res.data);
							let url = window.URL.createObjectURL(
								new Blob(binaryData, {
									type: "application/pdf"
								})
							)
							this.pdfUrl = url
						})

					}

				});
			},

			checkCategoryCode() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					if (this.level == 1) {
						res.data.map(item => {
							if (item.categoryCode == this.type) {
								this.selOneName = item.categoryName
								this.configList = item.children
							}
						})
					} else {
						res.data.map(item => {
							if (item.categoryCode == this.firstCategoryCode) {
								this.selOneName = item.categoryName
								this.configList = item.children
								this.configList.map(items => {
									if (items.categoryCode == this.type) {
										this.selName = items.categoryName
									}
								})
							}
						})
					}

				});
			},

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}
/deep/ .news_c img {
  height: auto !important;
}
</style>